// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2Qe9j","container":"Main_container__1guLf"};